import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#3649b6',
        secondary: '#42A5F5',
        accent: '#FF6F00',
        error: '#D32F2F',
        success: '#388E3C',
      }, dark: {

      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
